import { useState, useEffect, useRef } from 'react';

const faqs = [
  {
    q: 'Leke döküldüğünde ne yapılmalı?',
    a: 'Kesinlikle ovmamalısınız! Sadece temiz bir kağıt havluyla üstten bastırın ve sıvıyı ememesini sağlayın. Ovalama kiri kumaşın içine iter. Ardından hemen bizi arayın — ilk 24 saatte yapılan profesyonel müdahale çok daha etkili sonuç verir.',
  },
  {
    q: 'Yatak lekeleri gerçekten çıkar mı?',
    a: 'Büyük çoğunluğu çıkar, ancak derine işlemiş eski sarı lekeler tamamen çıkmayabilir. Size karşı dürüst olmak istiyoruz: leke ne kadar eski ve derin işlemişse, sonuç o kadar sınırlı olabilir. Taze lekelerde ise başarı oranımız çok yüksektir.',
  },
  {
    q: 'Petek temizliği sağlıklı mı? Zararlı bir şey var mı?',
    a: 'Hayır, petek temizliği tamamen güvenlidir. Kullandığımız kimyasallar insan ve çevre sağlığına uygun, sertifikalı ürünlerdir. Kombi sisteminize zarar vermeden, standartlara uygun makine ve yöntemlerle temizlik yapıyoruz.',
  },
  {
    q: 'İşlem ne kadar sürer?',
    a: 'Koltuk yıkama (1 koltuk): 45-60 dk. Sandalye yıkama (4 sandalye): 30-45 dk. Yatak yıkama (tek kişilik): 30-40 dk. Petek temizliği: Ev büyüklüğüne göre 2-4 saat. Kuruma süresi ise koltuk ve yatak için 2-3 saattir.',
  },
  {
    q: 'Hizmet vermediğiniz bölge var mı?',
    a: 'İstanbul genelinde Anadolu Yakası ve Avrupa Yakası\'na hizmet veriyoruz. Bazı uzak ilçelerde ekstra ulaşım ücreti uygulanabilir. Detay için bizi arayın veya WhatsApp\'tan mesaj gönderin.',
  },
  {
    q: 'Randevu için ne kadar önceden aranmalıyım?',
    a: 'Genellikle 1-2 gün öncesinden randevu almak yeterlidir. Yoğun dönemlerde (kış başı) 3-4 gün önceden planlamanızı öneririz. Acil durumlar için aynı gün randevu imkânı sunuyoruz, müsaitlik durumuna göre.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.05 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="faq" className="w-full bg-white py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <span className="inline-block text-emerald-600 font-semibold text-sm uppercase tracking-widest mb-3">
              Sık Sorulan Sorular
            </span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-[#1a1a1a] leading-tight"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Aklınızdaki Sorular
            </h2>
            <p className="text-gray-500 mt-3 text-base">
              Müşterilerimizin en çok sorduğu soruları yanıtladık.
            </p>
          </div>

          {/* Accordion */}
          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
                  open === i
                    ? 'border-emerald-200 shadow-sm'
                    : 'border-gray-100 hover:border-emerald-100'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer bg-white hover:bg-emerald-50/30 transition-colors"
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                >
                  <span className="font-semibold text-[#1a1a1a] text-sm md:text-base leading-snug">
                    {faq.q}
                  </span>
                  <span className={`w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    open === i ? 'bg-emerald-500 text-white rotate-45' : 'bg-gray-100 text-gray-500'
                  }`}>
                    <i className="ri-add-line" />
                  </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-gray-600 text-sm leading-relaxed px-5 pb-5 border-t border-gray-50 pt-4">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
